import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Input } from "antd";
import { find, filter } from 'lodash';

import * as constants from '../constants';
import {
    loadPersons
} from '../actions';

import uistate from '../../../../uistate';


class PersonsGrid extends Component {

    state = {
        selectedRowKeys: [],
        selectedRowName: '',
        filtertext: '',
    };

    UNSAFE_componentWillMount() {
        if (this.props.persons.length < 1) {
            this.props.loadPersons();
        }
    }

    setFilterText = (txt) => {
        this.setState({
            filtertext: txt.toLowerCase(),
        });
    }

    label = (key) => {
        if (this.props.labels) {
            return this.props.labels[constants.NAME]['PersonsGrid'][key];
        }
    }
    selectRow = (record) => {
        let selectedRowKeys = [];
        selectedRowKeys.push(record['idUser']);
        let selectedRowName = record["displayname"]; //evt uitbreiden met ander kolom waardes...
        this.setState({ selectedRowKeys, selectedRowName });
        if (this.props.onSelect) {
            this.props.onSelect(record['idUser'], selectedRowName);
        }
    }
    onSelectedRowKeysChange = (selectedRowKeys) => {
        const selectedentity = find(this.props.persons, { 'idUser': selectedRowKeys[0] });
        let selectedRowName = selectedentity["displayname"]; //evt uitbreiden met ander kolom waardes...
        this.setState({ selectedRowKeys, selectedRowName });
        if (this.props.onSelect) {
            this.props.onSelect(selectedRowKeys[0], selectedRowName);
        }
    }

    render() {
        const { selectedRowKeys, filtertext } = this.state;
        const columns = [{
            title: this.label('Firstname'),
            dataIndex: 'firstname',
            key: 'firstname',
            sorter: (a, b) => ('' + a.firstname).localeCompare(b.firstname),
        }, {
            title: this.label('Lastname'),
            dataIndex: 'lastname',
            key: 'lastname',
            sorter: (a, b) => ('' + a.lastname).localeCompare(b.lastname),
        }, {
            title: this.label('Displayname'),
            dataIndex: 'displayname',
            key: 'displayname',
            sorter: (a, b) => ('' + a.displayname).localeCompare(b.displayname),
        }, {
            title: this.label('Jobdescription'),
            dataIndex: 'jobdescription',
            key: 'jobdescription',
            sorter: (a, b) => ('' + a.jobdescription).localeCompare(b.jobdescription),
        }, {
            title: this.label('Company'),
            dataIndex: 'company',
            key: 'company',
            sorter: (a, b) => ('' + a.company).localeCompare(b.company),
        }];

        const rowSelection = {
            selectedRowKeys,
            type: 'radio',
            onChange: this.onSelectedRowKeysChange,
        };
        const filteredUsers = filter(this.props.persons, function (o) {
            return o.displayname.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(filtertext) || o.firstname.toLowerCase().includes(filtertext) || o.lastname.toLowerCase().includes(filtertext);
        });
        return (
            <div className='medewerkers'>
                <Input.Search autoFocus
                    placeholder={this.label("SearchText")}
                    onSearch={value => this.setFilterText(value)}
                    style={{ width: 300, marginLeft: 0, marginTop: 0, marginBottom: 10 }} />
                <br />
                <Table size="small" pagination={{ pageSize: 5 }}
                    dataSource={filteredUsers}
                    rowKey={record => record['idUser']}
                    rowSelection={rowSelection}
                    columns={columns}
                    onRow={(record) => ({
                        onClick: () => {
                            this.selectRow(record);
                        },
                        onDoubleClick: () => {
                            this.selectRow(record);
                            if(this.props.onDoubleClick){
                                this.props.onDoubleClick()
                            }
                        },
                    })}
                />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        persons: state[constants.NAME].persons,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        loadPersons
    })(PersonsGrid);